export default __webpack_public_path__ + "static/media/YPfinalsitemintv3.2988fc24.gif";